<template>
    <div>
        <rkm-area title="Procedimentos secundários">
            <template slot="trailing">
                <rkm-button
                    v-if="!data.model.exportado"
                    :disabled="!data.model.procedimentoPrincipal"
                    @click="handleAdd"
                    color="primary"
                    small
                    title="Adicionar"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>
            </template>

            <List :data="data" />
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'
import List from './List'

export default {
    components: { Modal, List },
    methods: {
        async validate() {

            return true
        },
        handleAdd() {

            if (!this.data.model.competenciaId || !this.data.model.paciente) {

                this.showWarningNotification('É necessário informar a competência e o paciente.')

                return
            }

            this.$refs.Modal.open()
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>